import { makeCrudBuilderInitialState } from "seneca-common/utils/apiStates";

import { courseEnrollmentsCrudConfig } from "../consts";

const courseEnrollmentsMetaInitialState = makeCrudBuilderInitialState(
  courseEnrollmentsCrudConfig
);

export default courseEnrollmentsMetaInitialState;
